import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography,
  DialogActions,
  Container,
  Stack,
} from "@mui/material";

const NumpadDialog = ({ open, onClose, onSubmit, selectedItem }) => {
  const S3_URL = process.env.REACT_APP_S3_URL;
  const [pin, setPin] = useState('');

  const handleButtonClick = (value) => {
    if (pin.length < 4) {
      setPin((prev) => prev + value);
    }
  };

  const handleDelete = () => {
    setPin((prev) => prev.slice(0, -1));
  };

  const handleConfirm = () => {
    if (pin.length === 4) {
      onSubmit(pin)
      setPin('')
    }
  };

  useEffect(() => {
    if (open === true) {
      setPin('')
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" >
      { selectedItem && (
        <div
          className="card"
        >
          <div className="avatar">
          {selectedItem.avatar_url && selectedItem.avatar_url !== '' ? (
            <img src={`${S3_URL}/img/user/${selectedItem.avatar_url}`} alt={selectedItem.name} className="avatar-img" />
          ) : (
            <div className="avatar-unavailable">👤</div>
          )}
          </div>
          <div className="info" >
            <span style={{ marginLeft: '10px' }}>{selectedItem.name}</span>
          </div>
        </div>
      )}
      <DialogTitle sx={{ textAlign: 'center' }}>Digite sua senha</DialogTitle>
      <DialogContent>
        <Box display="flex" justifyContent="center" mb={2}>
          <Typography variant="h5">{"•".repeat(pin.length).padEnd(4, "○")}</Typography>
        </Box>
        <Container>
          <Stack spacing={1} alignItems="center">
            {[[1, 2, 3], [4, 5, 6], [7, 8, 9], ["", 0, "⌫"]].map((row, rowIndex) => (
              <Stack key={rowIndex} direction="row" spacing={1} justifyContent="center">
                {row.map((item, index) => (
                  item !== "" ? (
                    <Button
                      key={index}
                      variant="contained"
                      color="#444444"
                      onClick={() => (item === "⌫" ? handleDelete() : handleButtonClick(item))}
                      sx={{
                        width: 60,
                        height: 60,
                        backgroundColor: '#8093a0',
                        color: 'white',
                        fontSize: '20px', // Aumenta o tamanho da fonte
                      }}
                    >
                      {item}
                    </Button>
                  ) : (
                    <Box key={index} sx={{ width: 60, height: 60 }} />
                  )
                ))}
              </Stack>
            ))}
          </Stack>
        </Container>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">Cancelar</Button>
        <Button onClick={handleConfirm} color="primary" disabled={pin.length !== 4}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NumpadDialog;